module.exports = __webpack_public_path__ + "97493d3f11c0a3bd5cbd959f5d19b699.woff2";